import React, {Component} from "react"
import {Button, Icon} from "semantic-ui-react"
import shop from "shop/shop"
import requestPassword from "components/Account/requestPassword"


export default class AccountReset extends Component {

  request = () => {
    const { email } = this.props
    console.log( `request PW RESET`, email, shop )
    requestPassword({email, shop})
  }

  render() {
    return <Button onClick={this.request} primary style={{width: "250px", borderRadius: "35px", height: "60px"}}><p className="fw6 f4"><Icon className="white lock"></Icon>{translate( "change Password" )}</p></Button>
  }
}



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Account/AccountReset.js